/**
 * Admin Utilities
 * Helper functions for admin access control and identification
 */

const ADMIN_EMAIL = 'chandra.kuncara@gmail.com';

/**
 * Check if a user is the admin
 * @param {Object} user - User object from Supabase auth
 * @returns {boolean} True if user is admin
 */
export function isAdmin(user) {
  return user && user.email === ADMIN_EMAIL;
}

/**
 * Get admin email (for reference/documentation)
 * @returns {string} Admin email address
 */
export function getAdminEmail() {
  return ADMIN_EMAIL;
}
